import { useState, useEffect } from "react";
import { getPollVotes, POLL_KEY } from "../utils/voterUtils";

const SAVED_POLLS_KEY = "saved_polls_v1";
const PASSWORD = "admin007";

function getSavedPolls() {
  try {
    return JSON.parse(localStorage.getItem(SAVED_POLLS_KEY) || "[]");
  } catch {
    return [];
  }
}

export default function Poll() {
  const [authed, setAuthed] = useState(false);
  const [pwInput, setPwInput] = useState("");
  const [pwError, setPwError] = useState(false);

  const [votes, setVotes] = useState([]);
  const [savedPolls, setSavedPolls] = useState([]);
  const [activePoll, setActivePoll] = useState(null);
  const [confirmReset, setConfirmReset] = useState(false);
  const [toastMsg, setToastMsg] = useState("");

  useEffect(() => {
    if (authed) {
      setVotes(getPollVotes());
      setSavedPolls(getSavedPolls());
    }
  }, [authed]);

  const showToast = (msg) => {
    setToastMsg(msg);
    setTimeout(() => setToastMsg(""), 2800);
  };

  const handleLogin = () => {
    if (pwInput === PASSWORD) { setAuthed(true); setPwError(false); }
    else setPwError(true);
  };

  const handleSaveAndNewPoll = () => {
    if (!confirmReset) { setConfirmReset(true); return; }
    const polls = getSavedPolls();
    polls.push({ savedAt: new Date().toLocaleString(), votes: [...votes] });
    localStorage.setItem(SAVED_POLLS_KEY, JSON.stringify(polls));
    localStorage.removeItem(POLL_KEY);
    setSavedPolls(polls);
    setVotes([]);
    setConfirmReset(false);
    setActivePoll(null);
    showToast("✅ Poll saved! New poll started.");
  };

  // ── Login Screen ──
  if (!authed) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontFamily: "'Georgia', serif",
      }}>
        <div style={{
          background: "rgba(255,255,255,0.05)",
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(255,255,255,0.15)",
          borderRadius: "16px",
          padding: "48px 40px", width: "360px",
          boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
          color: "white", textAlign: "center",
        }}>
          <div style={{ fontSize: "48px", marginBottom: "12px" }}>🗳️</div>
          <h2 style={{ fontWeight: "bold", marginBottom: "4px" }}>Poll Admin</h2>
          <p style={{ fontSize: "13px", color: "rgba(255,255,255,0.6)", marginBottom: "28px" }}>
            Enter password to access poll results
          </p>

          <input
            type="password"
            placeholder="Enter password..."
            value={pwInput}
            onChange={(e) => { setPwInput(e.target.value); setPwError(false); }}
            onKeyDown={(e) => e.key === "Enter" && handleLogin()}
            style={{
              width: "100%", padding: "12px 16px", borderRadius: "8px",
              border: pwError ? "2px solid #ff6b6b" : "1px solid rgba(255,255,255,0.2)",
              background: "rgba(255,255,255,0.1)", color: "white",
              fontSize: "16px", outline: "none", marginBottom: "8px",
            }}
          />
          {pwError && <p style={{ color: "#ff6b6b", fontSize: "13px", marginBottom: "12px" }}>❌ Incorrect password</p>}

          <button
            onClick={handleLogin}
            style={{
              width: "100%", padding: "12px",
              background: "linear-gradient(135deg, #f7971e, #ffd200)",
              border: "none", borderRadius: "8px",
              fontWeight: "bold", fontSize: "15px", cursor: "pointer",
              color: "#1a1a1a", marginTop: "8px",
            }}
          >
            Login →
          </button>

          <p style={{ marginTop: "20px", fontSize: "12px", color: "rgba(255,255,255,0.4)" }}>
            <a href="/" style={{ color: "rgba(255,255,255,0.5)", textDecoration: "none" }}>← Back to Voter Search</a>
          </p>
        </div>
      </div>
    );
  }

  const displayVotes = activePoll !== null ? savedPolls[activePoll].votes : votes;
  const displayTitle = activePoll !== null ? `Saved Poll — ${savedPolls[activePoll].savedAt}` : "Current Poll";

  return (
    <div style={{ minHeight: "100vh", background: "#f0f4f8", fontFamily: "'Segoe UI', sans-serif" }}>
      {/* Top Bar */}
      <div style={{
        background: "linear-gradient(135deg, #0f2027, #2c5364)",
        color: "white", padding: "16px 32px",
        display: "flex", justifyContent: "space-between", alignItems: "center",
        boxShadow: "0 2px 12px rgba(0,0,0,0.3)",
      }}>
        <div>
          <h4 style={{ margin: 0, fontWeight: "bold" }}>🗳️ Poll Admin Dashboard</h4>
          <p style={{ margin: 0, fontSize: "12px", opacity: 0.7 }}>
            {activePoll !== null ? displayTitle : `Live Poll · ${votes.length} unique vote(s) collected`}
          </p>
        </div>
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <a href="/select" style={{
            color: "rgba(255,255,255,0.8)", fontSize: "13px", textDecoration: "none",
            border: "1px solid rgba(255,255,255,0.3)", padding: "6px 14px", borderRadius: "6px",
          }}>🗳️ Vote Selection</a>
          <a href="/" style={{
            color: "rgba(255,255,255,0.8)", fontSize: "13px", textDecoration: "none",
            border: "1px solid rgba(255,255,255,0.3)", padding: "6px 14px", borderRadius: "6px",
          }}>← Voter Search</a>
          <button onClick={() => setAuthed(false)} style={{
            background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.3)",
            color: "white", padding: "6px 14px", borderRadius: "6px", cursor: "pointer", fontSize: "13px",
          }}>Logout</button>
        </div>
      </div>

      <div className="container py-4">
        {/* Stats */}
        <div className="row g-3 mb-4">
          <div className="col-md-3">
            <div style={{ background: "white", borderRadius: "12px", padding: "20px", boxShadow: "0 2px 10px rgba(0,0,0,0.07)", textAlign: "center" }}>
              <div style={{ fontSize: "32px", fontWeight: "bold", color: "#0d6efd" }}>{votes.length}</div>
              <div style={{ fontSize: "13px", color: "#6c757d" }}>Current Poll Votes</div>
            </div>
          </div>
          <div className="col-md-3">
            <div style={{ background: "white", borderRadius: "12px", padding: "20px", boxShadow: "0 2px 10px rgba(0,0,0,0.07)", textAlign: "center" }}>
              <div style={{ fontSize: "32px", fontWeight: "bold", color: "#198754" }}>{savedPolls.length}</div>
              <div style={{ fontSize: "13px", color: "#6c757d" }}>Saved Polls</div>
            </div>
          </div>
          <div className="col-md-6">
            <div style={{ background: "white", borderRadius: "12px", padding: "20px", boxShadow: "0 2px 10px rgba(0,0,0,0.07)", display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
              {confirmReset ? (
                <>
                  <span style={{ fontSize: "13px", color: "#dc3545", fontWeight: "600" }}>⚠️ Save current poll and start fresh. Confirm?</span>
                  <button className="btn btn-danger btn-sm" onClick={handleSaveAndNewPoll}>Yes, Save & Reset</button>
                  <button className="btn btn-secondary btn-sm" onClick={() => setConfirmReset(false)}>Cancel</button>
                </>
              ) : (
                <>
                  <button className="btn btn-warning" onClick={handleSaveAndNewPoll} disabled={votes.length === 0}>
                    💾 Save Poll & Start New
                  </button>
                  <span style={{ fontSize: "12px", color: "#6c757d" }}>Saves current list and clears for a new round</span>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Saved Poll Tabs */}
        {savedPolls.length > 0 && (
          <div className="mb-4">
            <h6 className="text-muted mb-2">📁 Saved Polls</h6>
            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
              <button className={`btn btn-sm ${activePoll === null ? "btn-primary" : "btn-outline-primary"}`} onClick={() => setActivePoll(null)}>
                Current ({votes.length})
              </button>
              {savedPolls.map((poll, idx) => (
                <button key={idx}
                  className={`btn btn-sm ${activePoll === idx ? "btn-success" : "btn-outline-success"}`}
                  onClick={() => setActivePoll(idx)}
                >
                  Poll {idx + 1} · {poll.votes.length} votes · {poll.savedAt}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Voter Table */}
        <div style={{ background: "white", borderRadius: "12px", boxShadow: "0 2px 12px rgba(0,0,0,0.08)", overflow: "hidden" }}>
          <div style={{ padding: "16px 24px", borderBottom: "1px solid #e9ecef", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h5 style={{ margin: 0, fontWeight: "600" }}>
              {displayTitle} — <span style={{ color: "#0d6efd" }}>{displayVotes.length} Distinct Voters</span>
            </h5>
          </div>

          {displayVotes.length === 0 ? (
            <div style={{ padding: "60px", textAlign: "center", color: "#adb5bd" }}>
              <div style={{ fontSize: "48px" }}>🗳️</div>
              <p style={{ marginTop: "12px" }}>No votes collected yet.</p>
              <p style={{ fontSize: "13px" }}>
                Go to <a href="/select" style={{ color: "#0d6efd" }}>Vote Selection</a> and mark voters.
              </p>
            </div>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table className="table table-hover mb-0">
                <thead style={{ background: "#f8f9fa" }}>
                  <tr>
                    <th style={{ width: "50px" }}>#</th>
                    <th>Voter Name</th>
                    <th>Relative Name</th>
                    <th>Voter ID</th>
                    <th>Serial No.</th>
                    <th>Age</th>
                    <th>Gender</th>
                  </tr>
                </thead>
                <tbody>
                  {displayVotes.map((row, i) => (
                    <tr key={i}>
                      <td style={{ color: "#6c757d", fontSize: "13px" }}>{i + 1}</td>
                      <td style={{ fontWeight: "500" }}>{row["VNAME"] || row["VNAMEENG"] || "-"}</td>
                      <td>{row["RNAME"] || row["RNAMEENG"] || "-"}</td>
                      <td><code style={{ fontSize: "12px", background: "#f0f4f8", padding: "2px 6px", borderRadius: "4px" }}>{row["VID"] || "-"}</code></td>
                      <td>{row["SNO"] || row["SRNO"] || "-"}</td>
                      <td>{row["AGE"] || "-"}</td>
                      <td>{row["GENDER"] || row["SEX"] || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Prediction */}
        {displayVotes.length > 0 && (
          <div style={{ marginTop: "24px", background: "linear-gradient(135deg, #0f2027, #2c5364)", borderRadius: "12px", padding: "28px 32px", color: "white" }}>
            <h5 style={{ fontWeight: "bold", marginBottom: "16px" }}>📊 Poll Prediction Summary</h5>
            <div className="row g-3">
              {[
                { label: "Unique Voters", value: displayVotes.length, color: "#ffd200" },
                { label: "Male Voters", value: displayVotes.filter(v => (v["GENDER"] || v["SEX"] || "").toUpperCase() === "M").length, color: "#51cf66" },
                { label: "Female Voters", value: displayVotes.filter(v => (v["GENDER"] || v["SEX"] || "").toUpperCase() === "F").length, color: "#f06595" },
              ].map(({ label, value, color }) => (
                <div key={label} className="col-md-4">
                  <div style={{ background: "rgba(255,255,255,0.1)", borderRadius: "10px", padding: "16px 20px", textAlign: "center" }}>
                    <div style={{ fontSize: "28px", fontWeight: "bold", color }}>{value}</div>
                    <div style={{ fontSize: "12px", opacity: 0.8 }}>{label}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* Age Bars */}
            {(() => {
              const groups = { "18-30": 0, "31-45": 0, "46-60": 0, "60+": 0 };
              displayVotes.forEach((v) => {
                const age = parseInt(v["AGE"]) || 0;
                if (age >= 18 && age <= 30) groups["18-30"]++;
                else if (age <= 45) groups["31-45"]++;
                else if (age <= 60) groups["46-60"]++;
                else if (age > 60) groups["60+"]++;
              });
              const total = displayVotes.length;
              return (
                <div style={{ marginTop: "20px" }}>
                  <p style={{ fontSize: "13px", opacity: 0.8, marginBottom: "12px" }}>Age Group Distribution</p>
                  {Object.entries(groups).map(([label, count]) => (
                    <div key={label} style={{ marginBottom: "8px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: "3px" }}>
                        <span>{label}</span>
                        <span>{count} ({total ? Math.round((count / total) * 100) : 0}%)</span>
                      </div>
                      <div style={{ height: "6px", background: "rgba(255,255,255,0.15)", borderRadius: "3px", overflow: "hidden" }}>
                        <div style={{ height: "100%", width: `${total ? (count / total) * 100 : 0}%`, background: "linear-gradient(90deg, #ffd200, #f7971e)", borderRadius: "3px", transition: "width 0.5s ease" }} />
                      </div>
                    </div>
                  ))}
                </div>
              );
            })()}
          </div>
        )}
      </div>

      {toastMsg && (
        <div style={{ position: "fixed", bottom: "24px", right: "24px", background: "#198754", color: "white", padding: "12px 20px", borderRadius: "8px", boxShadow: "0 4px 20px rgba(0,0,0,0.2)", fontSize: "14px", zIndex: 9999 }}>
          {toastMsg}
        </div>
      )}
    </div>
  );
}
